import {call} from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import {takeLatest, put} from 'redux-saga/effects';
import {
    getCollectionsList,
    collectionsSuccess,
    collectionsFailed,
    recordCollection,
    collectionRecordedSuccess,
    collectionRecordedFailed,
} from "../slices/collectionsSlice";
import {notification} from "antd";

const endpoint = '/admin/collections';

function* fetchCollections(action) {
    try {
        const response = yield call(HttpService.get, endpoint, action.payload);
        const {collections} = response.data;
        if (collections) {
            yield put(collectionsSuccess(collections));
        }
    } catch (error) {
        yield put(collectionsFailed());
    }
}

function* recordCollectionRequest(action) {
    try {
        const response = yield call(HttpService.post, `${endpoint}`, action.payload);
        if (response) {
            notification.success({message: 'Collection Recorded', description: 'Collection recorded successfully'});
            yield put(collectionRecordedSuccess());
        }
    } catch (error) {
        yield put(collectionRecordedFailed());
    }
}

export default function* resourcesSaga() {
    yield takeLatest(getCollectionsList.type, fetchCollections);
    yield takeLatest(recordCollection.type, recordCollectionRequest);
}
